
















































































// utils helpers
import mixins from '@/utils/mixins';

// mixins
import componentState from '@/mixins/state';

import { cloneDeep } from 'lodash';
import {
  Currency,
  CurrencyRate,
  CurrencyRateFieldError
} from '@/models/currency';
import { mapActions } from 'vuex';
import ErrorAlert from '../common/ErrorAlert.vue';
import { ErrorManager } from '@/models/error';
import ALDialog from '../core/Dialog/ALDialog.vue';
import { ALForm } from '@/common/component.types';

const baseMixins = mixins(componentState);

export interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    form: ALForm;
  };
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    components: { ErrorAlert, ALDialog },
    name: 'CurrencyFormDialog',

    data: () => ({
      valid: false,
      dialog: false,
      createForm: false,

      loading: false,

      currency: new CurrencyRate(),

      rateRules: [
        (v: any) => !!v || 'Rate is required',
        (v: any) => {
          if (!isNaN(parseFloat(v)) && v >= 0) return true;
          return 'Rate number be a number no less than 0';
        }
      ],

      errorMessage: '',
      detailErrorMessage: '',

      fieldError: new CurrencyRateFieldError()
    }),

    methods: {
      ...mapActions({
        updateCurrencyRate: 'currency/updateCurrencyRate'
      }),

      clearAllErrors(): void {
        this.errorMessage = '';
        this.detailErrorMessage = '';
        this.fieldError.clearErrors();
      },

      open(currency: CurrencyRate, createForm: boolean) {
        try {
          this.clearAllErrors();
          this.currency = cloneDeep(currency) ?? null;
          this.createForm = createForm;
          this.dialog = true;
          this.setComponentState('loaded');
          this.resetFormValidation();
        } catch (err) {
          this.setComponentState('error', err);
        }
      },

      resetFormValidation(): void {
        if (this.$refs.form) {
          return this.$refs.form.resetValidation();
        }
      },

      validateForm(): boolean {
        let valid = false;
        if (this.$refs.form) {
          valid = this.$refs.form.validate();
        }
        return valid;
      },

      async close() {
        this.dialog = false;
      },

      save() {
        if (this.validateForm()) {
          this.loading = true;
          if (this.createForm) {
            this.loading = false;
            this.close();
            throw new Error('Create not implemented as yet');
          } else {
            this.updateCurrencyRate({
              id: (this.currency.currency as Currency)?.id,
              rate: this.currency.rate
            })
              .then(() => this.close())
              .catch(error => {
                if (error.response) {
                  // client received an error response that falls out of range 2xx
                  if (
                    CurrencyRateFieldError.isCurrencyRateFieldError(
                      error.response.data
                    )
                  ) {
                    this.fieldError = new CurrencyRateFieldError(
                      error.response.data
                    );
                  } else if (error.response.data.detail) {
                    this.detailErrorMessage = error.response.data.detail;
                  }
                }
                this.errorMessage = ErrorManager.extractApiError(error);
              })
              .finally(() => {
                this.loading = false;
              });
          }
        }
      }
    }
  });
